import { render, staticRenderFns } from "./specific-admin.vue?vue&type=template&id=136ce5a3&"
import script from "./specific-admin.vue?vue&type=script&lang=js&"
export * from "./specific-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports